import { api } from "./api";

export const GET_ALL_PLANS = async () => {
    const { data } = await api.get("/plans")
    return data.plans || [];
}

export const GET_PLAN = async (id: string) => {
    const { data } = await api.get(`/plans/${id}`)
    return data;
}

export const DELETE_PLAN = async (id: string) => {
    const { data } = await api.delete(`/plans/${id}`)
    return data;
}

export const CREATE_PLAN = async (params: any) => {
    const { data } = await api.post(`/plans`, params)
    return data;
}

export const UPDATE_PLAN = async (id: string, params: any) => {
    const { data } = await api.patch(`/plans/${id}`, params)
    return data;
}

